import { createSlice } from '@reduxjs/toolkit';

export const reportsSlice = createSlice({
    name: 'reports',
    initialState: {
        loading: false,
        error: null,
        selectedReport: "",
        emails: ['resultados@happ.cl', 'jcofre@happ.cl', 'yaguayo@happ.cl', 'caraya@happ.cl'],
        reportsSuccess: false,
    },
    reducers: {
        initSendReports: state => {
            state.loading = true;
            state.error = null;
        },
        sendReportsSuccess: (state) => {
            state.loading = false;
            state.reportsSuccess = true;
        },
        sendReportsError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        setSelectedReport: (state, action) => {
            state.selectedReport = action.payload;
        },
        setEmails: (state, action) => {
            state.emails = action.payload;
        },
        setReportSucess: (state, action) => {
            state.reportsSuccess = action.payload;
        },
    },
});

export const {
    initSendReports,
    sendReportsSuccess,
    sendReportsError,
    setSelectedReport,
    setEmails,
    setReportSucess
} = reportsSlice.actions;